import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form, Formik } from 'formik';
import { Box, Paper, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import * as Yup from 'yup';

import TextFieldFormik from '../../common/text_field';
import { SubmitButton } from '../../common/button';
import { getTokenAction, getTokenState } from '../../../features/authorization/get_token';
import useNotification from '../../../core/hooks/use_notification';
import { getLanguagesNotificationData, getPodsNotificationData, getTokenNotificationData } from '../../../core/utils/notification_utils';
import { ApiRequestStatusEnum } from '../../../core/enums/common/api';
import { getLanguagesAction } from '../../../features/product/get_languages';
import { getAllPodsAction } from '../../../features/pod/get_all_pods';

const initialValues = { username: '', password: '' };

export const SignInPage = () => {
    const dispatch = useDispatch();
    const getToken = useSelector(getTokenState);
    const { showNotification, showErrorMessage } = useNotification();

    const onSubmit = (values) => {
        dispatch(getTokenAction({ username: values.username, password: values.password }))
            .then(response => {
                showNotification(getTokenNotificationData(response));

                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    dispatch(getLanguagesAction())
                        .then(response => showErrorMessage(getLanguagesNotificationData(response)));
                    dispatch(getAllPodsAction())
                        .then(response => showErrorMessage(getPodsNotificationData(response)));
                }
            });
    };

    const schema = Yup.object().shape({
        username: Yup.string().required(),
        password: Yup.string().required(),
    });

    return (
        <Paper
            elevation={ 0 }
            sx={ {
                p: { xs: 4, sm: 6 },
                width: '100%',
                borderRadius: 4,
                backgroundColor: 'background.paper',
                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
                border: theme => `1px solid ${ theme.palette.divider }`
            } }
        >
            <Stack alignItems="center" mb={ 4 }>
                <Box sx={ {
                    backgroundColor: 'primary.main',
                    borderRadius: '50%',
                    p: 1.5,
                    mb: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                } }>
                    <LockOutlinedIcon sx={ { color: 'white' } }/>
                </Box>
                <Typography variant="h5" fontWeight="600" align="center">
                    Logowanie do systemu
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={ { mt: 0.5 } }>
                    Wprowadź swoje dane uwierzytelniające
                </Typography>
            </Stack>

            <Formik
                initialValues={ initialValues }
                validationSchema={ schema }
                validateOnBlur={ false }
                validateOnChange={ false }
                onSubmit={ onSubmit }>
                <Form>
                    <Stack spacing={ 3 }>
                        <TextFieldFormik name="username" label="Login" required fullWidth/>
                        <TextFieldFormik name="password" label="Hasło" type="password" required fullWidth/>

                        <Box mt={ 1 }>
                            <SubmitButton
                                isLoading={ getToken?.loading }
                                sx={ { py: 1.5, fontSize: '1rem', width: '100%' } }
                            >
                                Zaloguj się
                            </SubmitButton>
                        </Box>
                    </Stack>
                </Form>
            </Formik>
        </Paper>
    );
};

export default SignInPage;